import { styled } from 'styled-components'

import { Breakpoints, Typography } from '@b-stock/fe-core/design-system'

export const MobileAccordionWrapper = styled.div`
  /* Mobile: Style accordion labels with Title2 */
  > div > div:first-child {
    ${Typography.Title2}
  }
  @media ${Breakpoints.min.medium} {
    /* Desktop/Tablet: Show content normally without accordion */
    > div > div:first-child {
      display: none; /* Hide accordion header */
    }
    > div > div:last-child {
      height: auto;
      overflow: visible;
      padding: 0;
    }
  }
`
